require.register("modules/m04s/m04s-activity/page-10/page-10", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page10 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page10;

  
});

